export default "__VITE_ASSET__CawqAg1y__ 400w, __VITE_ASSET__4aN2DVZO__ 800w, __VITE_ASSET__BpTEg$7l__ 1024w";